import { Element } from "react-scroll";
import LandingPage from "./Home/LandingPage";
import WhatWeDo from "./Home/WhatWeDo";
import FeaturedHighlights from "./Home/FeaturedHighlights";
import FeaturedArticles from './Home/FeaturedArticles';
import FeaturedIncubatees from './Home/FeaturedIncubatees';
import FeaturedPrograms from './Home/FeaturedProgram';
import PartnersSection from "./Home/PartnershipPage";
import AboutUs from "./Home/AboutUs";
import OurTeam from "./Home/OurTeam";
import HowToApplyCard from "./Home/HowToApplyCard";
import MissionVision from "./Home/MissionVision";
import HighlightPhoto from "./Home/HighlightPhoto";

export default function HomePage({ onApplyClick }) {
  return (
    <main className="min-h-screen flex flex-col text-sm sm:text-base overflow-hidden">

      <Element name="home">
        <LandingPage onApplyClick={onApplyClick} />
      </Element>

      <div id="howtoapply" className="relative z-40 -mt-28 sm:-mt-32 md:-mt-36 lg:-mt-80 xl:-mt-[25%] mb-[-6rem] sm:mb-[-7rem] md:mb-[-8rem]">
        <HowToApplyCard />
      </div>
      <div id="whatwedo"></div>
      <WhatWeDo />
      {/* <FeaturedHighlights /> */}
      <div id="articles"></div>
      <FeaturedArticles />
      <div id="incubatees"></div>
      <FeaturedIncubatees />
      <div id="programs"></div>
      <FeaturedPrograms />
      <div id="partners"></div>
      <PartnersSection />
      <div id="about"></div>
      <AboutUs onApplyClick={onApplyClick}/>
      <div id="missionvision"></div>
      <MissionVision/>
      <HighlightPhoto/>
      <div id="team"></div>
      <OurTeam />
    </main>
  );
}